
import { defineComponent, PropType, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import type { SitePassTimeData } from './index';

export default defineComponent({
  name: 'SitePassTimeForm',

  components: {
    Button,
    InputNumber,
    Dropdown,
  },

  props: {
    modelValue: {
      type: Object as PropType<SitePassTimeData>,
      default: () => ({
        time_unit_select: { unit: 'MINUTE', value: 10 },
        multiplebox_global_session: 'global',
      }),
    },
    formValidation: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['update:modelValue', 'cancel', 'close', 'submit'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const localData = ref<SitePassTimeData>({
      time_unit_select: { ...props.modelValue.time_unit_select },
      multiplebox_global_session: props.modelValue.multiplebox_global_session,
    });

    const timeUnits = [
      { value: 'SECOND', label: t('flows.operators.sitePassTime.seconds') },
      { value: 'MINUTE', label: t('flows.operators.sitePassTime.minutes') },
      { value: 'HOUR', label: t('flows.operators.sitePassTime.hours') },
    ];

    const sessionOptions = [
      {
        value: 'global',
        label: t('flows.operators.sitePassTime.global'),
        description: t('flows.operators.sitePassTime.globalDesc'),
        icon: 'far fa-globe',
      },
      {
        value: 'session',
        label: t('flows.operators.sitePassTime.session'),
        description: t('flows.operators.sitePassTime.sessionDesc'),
        icon: 'far fa-window',
      },
    ];

    watch(localData, (newData) => {
      emit('update:modelValue', newData);
    }, { deep: true });

    watch(() => props.modelValue, (newValue) => {
      if (newValue !== localData.value) {
        localData.value = {
          time_unit_select: { ...newValue.time_unit_select },
          multiplebox_global_session: newValue.multiplebox_global_session,
        };
      }
    });

    return {
      t,
      localData,
      timeUnits,
      sessionOptions,
    };
  },
});
